import React, { useState } from "react";
import PopUp from "./PopUp";
import ArrowDropDownCircleOutlinedIcon from "@mui/icons-material/ArrowDropDownCircleOutlined";
import ResetModal from "./ResetModal";
import CareTeamModel from "./CareTeamModel";
import { useDispatch, useSelector } from "react-redux";
import { user } from "redux-store/user/user.selectors";
import { useNavigate } from "react-router-dom";
import UserDetailsModel from "./UserDetailsModel";
import SinglePetDetailModel from "./SinglePetDetailModel";
import { AppDispatch } from "redux-store/store";
import { getAllTests, resetsubmittedTests } from "redux-store/lab-tests/tests.slice";

type Propstype = {
  result?: any;
  isSubmitted?: boolean;
  setSubmitted?: any;
};
const LabResultRow = ({ result, isSubmitted, setSubmitted }: Propstype) => {
  const [open, setOpen] = useState(false);
  const [showPetModel, setShowPetModel] = useState(false);
  const [showVetModel, setShowVetModel] = useState(false);
  const [showUserModel, setShowUserModel] = useState(false);
  const [userId, setUserId] = useState(null);
  const [petId, setPetId] = useState(null);
  const loggedInUser = useSelector(user);
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);
  const handleResetData = () => {
    dispatch(resetsubmittedTests(result?._id))
      .then(() => {
        setModalOpen(false);
        dispatch(getAllTests({ page: 1 }));
      })
      .catch((error) => {
        console.error("Error resetting data:", error);
      });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSubmitted(true);
  };
  const handlePetModelClose = () => {
    setShowPetModel(false);
  };
  const handleVetClick = () => {
    setUserId(result.userId._id);
    setShowVetModel(true);
  };

  const handleSinglePetOpen = (petId: any) => {
    setPetId(petId);
    setShowPetModel(true);
  };

  const reportDownloadHandler = (id: any) => {
    navigate(`/parent-test-result`, { state: result });
  };

  return (
    <>
      <div className="tw-flex tw-items-center tw-justify-between tw-pb-2">
        <div
          onClick={() => {
            setShowUserModel(true);
          }}
          className="tw-flex-1 tw-cursor-pointer tw-text-xl tw-text-[#000000] tw-font-normal"
        >
          {result?.userId?.fullName && result.userId.fullName}
        </div>
        <div
          onClick={() => handleSinglePetOpen(result?.petId?._id)}
          className="tw-flex-1 tw-cursor-pointer tw-text-xl tw-text-[#000000] tw-font-normal tw-truncate"
        >
          {result?.petId?.petName}
        </div>
        <div className="tw-flex-1 tw-text-xl tw-text-[#000000] tw-font-normal">
          {result.riskLevel ? result.riskLevel : <ArrowDropDownCircleOutlinedIcon onClick={handleClickOpen} />}
        </div>
        <div className="tw-flex-1 tw-text-xl tw-text-[#000000] tw-font-normal">
          {result.riskValue ? result.riskValue : <ArrowDropDownCircleOutlinedIcon onClick={handleClickOpen} />}
        </div>

        {loggedInUser?.isHospital ? (
          <div className="tw-flex tw-flex-1 tw-gap-2">
            <div className="tw-w-[80%] tw-gap-2 tw-mx-auto tw-flex tw-items-center tw-justify-center">
              <button
                className="tw-flex tw-items-center tw-justify-center tw-text-lg tw-text-[#FFFFFF] tw-font-bold tw-bg-[#FF7B6D] tw-py-2 tw-px-8 tw-rounded-md"
                onClick={() => reportDownloadHandler(result?._id)}
              >
                Download
              </button>
            </div>
          </div>
        ) : (
          <div className="tw-flex tw-flex-1 tw-gap-2">
            <div className="tw-flex tw-items-center">
              {isSubmitted && (
                <>
                  <button className="tw-text-[#FF7B6D] tw-underline" onClick={handleOpenModal}>
                    Reset
                  </button>
                  <div className="">
                    <ResetModal isOpen={isModalOpen} onClose={handleCloseModal} onConfirm={handleResetData} />
                  </div>
                </>
              )}
            </div>
            {isSubmitted ? (
              <button className="tw-flex tw-items-center tw-justify-center tw-text-lg tw-text-[#FFFFFF] tw-font-bold tw-bg-[#FF7B6D] tw-py-2 tw-px-3 tw-rounded-md">
                Submitted
              </button>
            ) : (
              <button
                className="tw-flex tw-items-center tw-justify-center tw-text-lg tw-text-[#000] tw-font-bold tw-py-1 tw-px-5 tw-rounded-lg tw-border-black tw-border-2"
                onClick={handleClickOpen}
              >
                Submit
              </button>
            )}
            <div>
              <button
                onClick={handleVetClick}
                className={`tw-flex tw-items-center tw-justify-center tw-text-lg tw-text-[#000] tw-font-bold tw-py-1 ${
                  isSubmitted ? "tw-px-3" : "tw-px-5"
                } tw-rounded-lg tw-border-black tw-border-2`}
              >
                Vet
              </button>
            </div>
          </div>
        )}
      </div>
      <hr className="tw-w-[70%] tw-mt-2" />
      <PopUp handleClose={handleClose} open={open} result={result} />
      <SinglePetDetailModel handlePetModelClose={handlePetModelClose} open={showPetModel} petId={petId} />
      <CareTeamModel
        setShowVetModel={setShowVetModel}
        showVetModel={showVetModel}
        userId={userId}
        showButtons={false}
      />
      <UserDetailsModel
        onClose={() => setShowUserModel(false)}
        open={showUserModel}
        user={result?.userId}
      ></UserDetailsModel>
    </>
  );
};

export default LabResultRow;
